import { auSoftwarePackages } from './pages/softwarePackages/au.softwarePackages';
import { PressRoomImages } from '@helpers/staticImages/pressRoom';
import { contactUs, videos } from '@helpers/staticImages/staticPages';

export const au = {
    notFound: {
        title: '404 Not Found | Geotab',
        heading: 'Oh no!',
        description: 'The page you were looking for could not be found.',
        description2: 'Try searching or go back to',
        homepageLink: 'our homepage',
        redirectLink: '/',
    },
    micrositeForm: {
        title: 'Connect with an authorised reseller',
        subTitle:
            'Let us show you how simple it is to use our web-based software and telematics devices to manage your fleet.',
        countryName: 'Australia',
        firstName: 'First name',
        lastName: 'Last name',
        company: 'Company',
        email: 'Email',
        fleetSize: 'Fleet size',
        phone: 'Phone',
        country: 'Country',
        state: 'State/Province',
        city: 'City',
        submitButton: 'Submit',
        tooltip: {
            pleaseFillOutThisField: 'Please fill out this field',
            pleaseSelectAnItem: 'Please select an item in the list',
        },
    },
    successStoriesTemplate: {
        publishedOn: 'Published on',
        clientProfile: 'Client profile',
        name: 'Client name',
        industry: 'Industry',
        typesOfVehicles: 'Types of vehicles',
        fleetSize: 'Fleet size',
        fleetFocus: 'Fleet focus',
        otherStories: 'Other stories',
        optimizeYourFleet: 'Ready to optimize your fleet?',
        letUsShowYou:
            'Let us show you how simple it is to use our web-based software and fleet tracking devices to manage your fleet.',
        requestDemo: 'Request a demo',
        requestDemoPath: '/request-demo/',
        visitBlog: 'Visit the blog',
        downloadSuccessStory: 'Download PDF',
    },
    whitePapersHome: {
        seo: {
            title: 'Fleet Management Whitepaper Reads',
            description:
                'The latest Whitepapers from Geotab. Learn how Geotab`s end to end fleet management solution can help your business.',
        },
        page: 'Page',
        title: 'White papers',
    },
    whitePaper: {
        articleCard: {
            publishedOn: 'Published on',
            downloadWhitePaper: 'Download white paper',
        },
        allWhitePapers: 'All white papers',
    },
    video: {
        blogCard: {
            image: {
                imagePath: videos.blogGraphic,
                imageAlt: 'An illustration of two individuals reading an oversized book with a coloured bookmark.',
            },
            title: 'Blog',
            body: 'Your online source of fleet management and mobility news, insights and best practices.',
            linkPath: '/au/blog/',
            linkText: 'Visit blog',
            linkTarget: true,
        },
        whitePaperCard: {
            image: {
                imagePath: videos.whitePapersGraphic,
                imageAlt: 'An illustration of two individuals interacting with some documents and a magnifying glass.',
            },
            title: 'White papers',
            body: ' Fleet management resources to help you optimise and grow your business.',
            linkPath: '/au/white-papers/',
            linkText: 'Read white papers',
            linkTarget: true,
        },
        communityCard: {
            image: {
                imagePath: videos.forumsGraphic,
                imageAlt: 'An illustration of two individuals interacting with technology and messages.',
            },
            title: 'Community',
            body: 'Ask questions, share experiences, learn from peers and help shape the future of telematics.',
            linkPath: 'https://community.geotab.com/s/',
            linkText: 'Visit Community',
            linkTarget: true,
        },
    },
    regionSelection: {
        seo: {
            title: 'Region Selection',
            description:
                'Select your country or region to learn about Geotab\'s fleet management software and vehicle tracking devices.',
        },
        title: 'Select your region',
        regions: {
            northSouthAmerica: 'North and South America',
            europe: 'Europe',
            asiaAustraliaMiddleEast: 'Asia, Australia, and Middle East',
        },
        regionChangeText: 'Change language',
    },
    salesforce: {
        formLanguage: 'English AU',
        demoFormDefaultCampaignId: '7012J000001YhJrQAK',
    },
    pressRoomHome: {
        seo: {
            title: 'Press room and Media News',
            description:
                'View the latest telematics and fleet management news and Geotab updates in the Geotab Press room and Media News.',
        },
        allPressReleases: 'All press releases',
        pressKit: {
            pressKitTitle: 'Press Kit',
            ourAvailableResources: 'Our available resources for journalists. For media inquiries, email: ',
            pressKitList: [
                {
                    name: 'Corporate profile',
                    url: '/au/about/',
                    image: PressRoomImages.corpProfile,
                },
                {
                    name: 'Leadership bios',
                    url: '/au/about/leadership/',
                    image: PressRoomImages.leadershipBio,
                },
                {
                    name: 'Fact sheet',
                    url: 'https://docs.google.com/document/d/1Bct3-Z9FCtl15C7DS8iGWtoE7Ckc6IgvRbv9cRqmYFw/edit?usp=sharing',
                    image: PressRoomImages.mediaGuidelines,
                },
                {
                    name: 'Third party press release policy',
                    url: 'https://docs.google.com/document/d/1op_dyBGG99rBjB4GEcV8vArEqrXKo7pqoNG3l-kuqkY/edit?usp=sharing',
                    image: PressRoomImages.legalPolicy,
                },
            ],
        },
        pressRoomSectionListCards: {
            latestUpdates: 'Latest updates',
            inOtherNews: 'In Other News',
        },
    },
    authorBiography: {
        authorOverview: {
            leanMoreAbout: 'Learn more about {authorName}',
        },
        authorPosts: {
            postsBy: 'Posts by',
            postBy: 'Post by',
            noPostAvailable: 'No posts available',
        },
        publications: 'Publications',
    },
    generalInquiries: {
        seo: {
            title: 'General inquiries | Geotab',
            description: 'Have a question? Please fill out the form below and we will contact you as soon as possible.',
        },
        heroImagePath: contactUs.generalInquiriesHeroImage,
        title: 'General inquiries',
        header: 'Contact us',
        subtext: 'Have a question? Please fill out the form below and we will contact you as soon as possible.',
        inquiryType: 'Other',
    },
    resellerForm: {
        seo: {
            title: 'Reseller inquiry | Geotab',
            description:
                'Interested in becoming a Geotab Reseller? Please fill in the form below and we will contact you as soon as possible.',
        },
        heroImagePath: contactUs.resellerSupport,
        title: 'Reseller inquiry',
        header: 'Contact Reseller support',
        subtext:
            'Interested in becoming a Geotab Reseller? Please fill in the form below and we will contact you as soon as possible.',
        inquiryType: 'Become a Reseller/Partner',
    },
    blogHome: {
        featured: 'Featured',
        browseCategories: 'Browse categories',
        editorsPicks: 'Editor\'s picks',
        newestPosts: 'Newest Posts',
        viewAll: 'View all',
    },
    categories: {
        all: 'all',
        allCategoriesTitleTag: 'View all blog posts.',
        categoriesTitleTag: 'View posts in',
        geotabAuthor: 'Geotab author',
        page: 'Page',
        fleetManagementBlog: 'Fleet Management Blog',
    },
    formPlaceholders: {
        firstNamePlaceholder: 'Enter a first name\u2026',
        lastNamePlaceholder: 'Enter a last name\u2026',
        phonePlaceholder: 'Enter a phone number\u2026',
        emailPlaceholder: 'Enter an email\u2026',
        companyPlaceholder: 'Enter a company\u2026',
        cityPlaceholder: 'Enter a city\u2026',
        commentsPlaceholder: 'Enter any questions/comments\u2026',
        fleetPlaceholder: 'Select a fleet size\u2026',
        countryPlaceholder: 'Select a country\u2026',
        messagePlaceholder: 'Enter a message\u2026',
        identityPlaceholder: 'Select a category\u2026',
        surnamePlaceholder: 'Enter a surname\u2026',
        fullNamePlaceholder: 'Enter a full name\u2026',
        statePlaceholder: 'Select a state\u2026',
        provincePlaceholder: 'Select a province\u2026',
        titlePlaceholder: 'Select a title\u2026',
        userTitlePlaceholder: 'Enter a title\u2026',
        industryPlaceholder: 'Select an industry category\u2026',
        selfAttributionPlaceholder: 'Enter how you heard about Geotab\u2026',
    },
    softwarePackages: auSoftwarePackages,
    myGeotabLogin: {
        loginText: 'Log in',
        registerText: 'Register',
        newsText: 'Featured news',
        seo: {
            title: 'MyGeotab Login / Register | Australia | Geotab',
            description:
                'Log in securely to your MyGeotab dashboard. Don\'t have an account? Register as a new user in North America.',
        },
        heading: 'Australia MyGeotab Login / Register',
    },
    EVFormAUNZ: {
        title: 'Get a demo today!',
        subTitle: 'Let Geotab help guide you through the transition to an electric, connected vehicle fleet.',
        formField: {
            firstName: 'First name',
            lastName: 'Last name',
            company: 'Company name',
            email: 'Email',
            phone: 'Phone',
            selectCountry: 'Country',
            formID: 'au-ev-form',
            consentTextSentence:
                'Yes, I would like to receive marketing communications regarding Geotab products, services, and events. Your information will be used in accordance with ',
            consentLinkText: 'Geotab’s privacy policy.',
            consentLink: 'https://www.geotab.com/privacy-policy/',
            submit: 'Submit',
        },
    },
    transportationContactForm: {
        title: 'Get a demo today!',
        subTitle: 'Gain useful insights into flexible, cost competitive strategies for Heavy Goods fleets.',
        formField: {
            firstName: 'First name',
            lastName: 'Last name',
            company: 'Company name',
            city: 'City',
            email: 'Email',
            phone: 'Phone',
            selectCountry: 'Country',
            fleetSize: 'Fleet Size',
            consentTextSentences: [
                'Yes, I would like to receive marketing communications regarding Geotab products, services, and events. ',
                'Your information will be used in accordance with ',
            ],
            consentLinkText: 'Geotab’s privacy policy.',
            consentLink: 'https://docs.google.com/document/d/1sVygLN02w2xNovFY4q5vw-oAzfYxCd7WLhyToElgDbs/pub',
            submit: 'Submit',
        },
    },
    blogTableContent: {
        title: 'Table of contents',
    },
    articleFAQ: {
        title: 'Frequently Asked Questions',
    },
    blogInfo: {
        readMinutes: '5 minute read',
        by: 'By',
    },
    requestDemo: {
        optimizeYourFleetToday: 'Optimize your fleet today',
        formField: {
            leadSource: 'Geotab Demo Form',
            firstName: 'First name',
            lastName: 'Last name',
            company: 'Company',
            email: 'Email',
            selectFleetSize: 'Select fleet size',
            phone: 'Phone',
            selectCountry: 'Select Country',
            city: 'City',
            industry: 'Select Industry',
            selfAttribution: 'How did you hear about us?',
            consentText:
                'Yes, I would like to receive marketing communications regarding Geotab.com products, services, newsletters, and events. Your information will be used in accordance with Geotab’s <a href="https://docs.google.com/document/d/1sVygLN02w2xNovFY4q5vw-oAzfYxCd7WLhyToElgDbs/pub" rel="noopener" target="_blank">privacy policy</a>.',
            requestAFreeDemo: 'Request a free demo',
            formTitle: 'Sign up for a FREE demo',
            businessEmail: 'Business Email',
            areaOfInterest: 'Area of Interest',
        },
    },
    aboutGeotab: {
        main: 'About Geotab',
        content:
            'Geotab is a global leader in connected vehicle and asset solutions, helping fleets boost their efficiency and management. We use advanced data analytics and AI to transform fleet performance, safety, and sustainability, reducing costs and driving efficiency.  Supported by top data scientists and engineers, we serve over 55,000 customers worldwide, processing 80 billion data points daily from more than 4.7 million vehicle subscriptions. Geotab is trusted by Fortune 500 companies, mid-sized fleets, and the biggest public sector fleets globally, including the US Federal Government. Committed to data security and privacy, we hold FIPS 140-3 and FedRAMP authorisations. Our open platform, network of excellent partners, and Marketplace deliver hundreds of ready-to-go third-party solutions for fleets. This year, we\'re celebrating 25 years of innovation. Find out more at <a href="https://www.geotab.com/au" target="_blank">www.geotab.com/au</a>, and follow us on <a href="https://www.linkedin.com/company/geotab/" target="_blank" rel="noopener noreferrer">LinkedIn</a> or visit our <a href="https://www.geotab.com/au/blog/" target="_blank">blog</a>.',
        rights: 'All Rights Reserved.',
        disclaimer:
            'This white paper is intended to provide information and encourage discussion on topics of interest to the telematics community. Geotab is not providing technical, professional or legal advice through this white paper. While every effort has been made to ensure that the information in this white paper is timely and accurate, errors and omissions may occur, and the information presented here may become out-of-date with the passage of time.',
    },
    aboutAuthor: {
        about: 'About',
        currentRole: 'Current role',
        experties: 'Expertise',
        accomplishments: 'Accomplishments',
        education: 'Education',
        publications: 'Publications',
    },
    mobileStickyBanner: {
        text: 'Schedule a demo',
        link: '/au/request-demo/',
    },
    breadcrumb: {
        home: 'Home',
    },
    contactSection: {
        title: 'CONTACT US',
        subHeading: 'How can we direct your inquiry?',
        salesInquiryText: 'Sales inquiry',
        salesInquiryImageAlt: 'Price tag icon',
        salesInquiryLink: '/au/contact-us/sales-inquiry/',
        customerSupportText: 'Customer support',
        customerSupportImageAlt: 'Customer chat icon',
        customerSupportLink: 'https://support.geotab.com/',
        contactLinks: [
            {
                title: 'Request demo',
                href: 'https://www.geotab.com/au/request-demo/',
            },
            {
                title: 'Become a reseller',
                href: 'https://www.geotab.com/au/contact-us/become-a-reseller/',
            },
        ],
    },
};
